import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import type { ApiChoiceResponseItem } from '@/features/ChoicesLists/Api/types';

export class ProfessionsHttpService extends HttpService {
  loadProfessions(
    ...requestArguments: string[]
  ): HttpClientResponse<ApiChoiceResponseItem[]> {
    return this.httpClient.get(`innoBerufe?beruf=${requestArguments[0]}`);
  }
}
